import { EnhancedScopeData } from '@ardoq/data-model';
import { useEffect, useRef, useState } from 'react';
import { EnhancedScopeDataWithBranchName } from '../../scopeData/enhanceScopeData';

export const useElementWidth = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<null | number>(null);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      const handle = requestAnimationFrame(() => {
        const { width } = el.getBoundingClientRect();
        setWidth(width);
      });

      return () => cancelAnimationFrame(handle);
    }
  }, []);

  return { ref, width };
};
export const isEnhancedScopeDataWithBranchName = (
  enhancedScopeData: EnhancedScopeData | EnhancedScopeDataWithBranchName
): enhancedScopeData is EnhancedScopeDataWithBranchName =>
  enhancedScopeData &&
  (enhancedScopeData as EnhancedScopeDataWithBranchName).branchName !==
    undefined;
